import type { Job } from '../../../types';

// visible !== false необходимо для превью вакансий, не упрощайте это условие
export const getVisibleJobs = (jobs: Job[]) =>
  jobs.filter(({ visible }) => visible !== false);
